import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
  Stack,
  Typography,
} from "@altimateai/lego";
import { IconCheck, IconChevronDown } from "@tabler/icons-react";
import { WorkloadAttribute } from "../types";

interface GroupByDropdownProps {
  value: string;
  onChange: (value: string) => void;
  options?: WorkloadAttribute[];
  /** Override the trigger / menu label (defaults to "Group by"). */
  label?: string;
}

export const GroupByDropdown = ({
  value,
  onChange,
  options = [],
  label = "Group by",
}: GroupByDropdownProps) => {
  const selectedLabel = options.find(o => o.key === value)?.label || value;

  const nonCustomOptions = options.filter(option => !option.is_custom);
  const customOptions = options.filter(option => option.is_custom);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" className="al-gap-2">
          <Typography variant="body" size="sm" className="al-text-muted-foreground">
            {label}:
          </Typography>
          <Typography variant="body" size="sm" className="al-text-primary">
            {selectedLabel}
          </Typography>
          <IconChevronDown className="al-h-4 al-w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="al-min-w-44">
        <DropdownMenuLabel>{label}:</DropdownMenuLabel>
        <DropdownMenuGroup>
          {nonCustomOptions.map(option => (
            <DropdownMenuItem key={option.key} onClick={() => onChange(option.key)}>
              <Stack direction="row" align="center" justify="between" className="al-w-full">
                <span>{option.label}</span>
                {value === option.key && <IconCheck className="al-h-4 al-w-4 al-text-primary" />}
              </Stack>
            </DropdownMenuItem>
          ))}
        </DropdownMenuGroup>
        {customOptions.length > 0 && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuLabel>Custom Tags</DropdownMenuLabel>
            <DropdownMenuGroup>
              {customOptions.map(option => (
                <DropdownMenuItem key={option.key} onClick={() => onChange(option.key)}>
                  <Stack direction="row" align="center" justify="between" className="al-w-full">
                    <span>{option.label}</span>
                    {value === option.key && (
                      <IconCheck className="al-h-4 al-w-4 al-text-primary" />
                    )}
                  </Stack>
                </DropdownMenuItem>
              ))}
            </DropdownMenuGroup>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default GroupByDropdown;
